import { z } from 'zod';
import { NewsListSchema } from './news-list.schema';
import { paginationSchema } from 'services/generic';

export const getNewsResponseSchema = paginationSchema.extend({
    items: NewsListSchema,
});

export const getNewsRequestParamsSchema = z.object({
    tag: z.string().optional(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
    lang: z.string().optional(),
});